// src/components/features/Cart/CheckoutWrapper.js
import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Checkout from './Checkout';

// FORCE LIVE MODE with explicit configuration
const getStripePromise = () => {
  // Clear any cached Stripe instance first
  if (window.Stripe) {
    delete window.Stripe;
  }
  
  return loadStripe('pk_live_51SZhsdHcvLhJFUKBH5JOpw6WL8Dl71UCM11UFfLrcP8ySy4PS5nf0TRuf5m54UjUY7I88WqP2Q3UEchYOrFMxc9200tyNnuLkk', {
    // Explicit live mode configuration
    stripeAccount: undefined,
    apiVersion: '2023-10-16',
    // Force live mode
    betas: [],
    locale: 'en',
    // Advanced options to prevent test mode
    advancedFraudSignals: true,
  });
};

const CheckoutWrapper = () => {
  const [stripePromise, setStripePromise] = useState(() => getStripePromise());

  // Clear Stripe cache on mount
  useEffect(() => {
    // Clear localStorage
    Object.keys(localStorage).forEach(key => {
      if (key.includes('stripe') || key.includes('__stripe')) {
        localStorage.removeItem(key);
      }
    });
    
    // Clear cookies
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.split('=').map(c => c.trim());
      if (name.includes('__stripe')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  }, []);

  return (
    <Elements 
      stripe={stripePromise}
      options={{
        mode: 'payment',
        currency: 'gbp',
        // Disable any test mode features
        paymentMethodCreation: 'manual',
        // Explicit appearance
        appearance: {
          theme: 'stripe',
          variables: {
            colorPrimary: '#009de0',
            colorBackground: '#ffffff',
            colorText: '#32325d',
          },
        },
      }}
    >
      <Checkout />
    </Elements>
  );
};

export default CheckoutWrapper;